var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontalLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1336,
    height: 10,
    viewBox: "0 0 1336 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255 7.24998C255 8.74998 256.382 10 258.04 10H264.121C265.779 10 267.161 8.74998 267.161 7.24998V5.625H1324V4.375H267.161V2.75002C267.161 1.25002 265.779 0 264.121 0L258.04 0C256.382 0 255 1.25002 255 2.75002V4.375H0L0 5.625H255V7.24998Z",
    fill: "#ED1957"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1326.88 10C1325.31 10 1324 8.74998 1324 7.24998V2.75002C1324 1.25002 1325.31 0 1326.88 0L1332.63 0C1334.19 0 1335.5 1.25002 1335.5 2.75002V7.24998C1335.5 8.74998 1334.19 10 1332.63 10H1326.88Z",
    fill: "#ED1957"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M793.875 10C792.307 10 791 8.74998 791 7.24998V2.75002C791 1.25002 792.307 0 793.875 0L799.625 0C801.193 0 802.5 1.25002 802.5 2.75002V7.24998C802.5 8.74998 801.193 10 799.625 10H793.875Z",
    fill: "#ED1957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalLine);
export default __webpack_public_path__ + "static/media/horizontal-line.05dc30bb6ef582c6f1f59e29c410d1da.svg";
export { ForwardRef as ReactComponent };